//import Vue from 'vue'
import Vue from 'vue/dist/vue.esm.js'

import Router from 'vue-router'
import Login from '@/components/login/login'
import HomePage from '@/components/index/homePage'
import Home from '@/components/home'
import PersonalCenter from '@/components/login/personalCenter'

// 实时监控
import EquipmentMonitoring from '@/components/realTimeMonitoring/equipmentMonitoring'
import VideoMonitoring from '@/components/realTimeMonitoring/videoMonitoring'
import ElectricityMonitoring from '@/components/realTimeMonitoring/electricityMonitoring'


// 经营分析
import ChargingRevenue from '@/components/dataAnalysis/chargingRevenue'
import OperationAnalysis from '@/components/dataAnalysis/operationAnalysis'
import fundRecord from '@/components/dataAnalysis/fundRecord'


// 场站管理
import ElectricityPayment from '@/components/stationManagement/electricityPayment'
import DeviceManagement from '@/components/stationManagement/deviceManagement'
import TaskManagement from '@/components/stationManagement/taskManagement'
import StationList from '@/components/stationManagement/stationList'

// 充电管理
import ChargingRecord from '@/components/chargeManagement/chargingRecord'
import ChargingTemplate from '@/components/chargeManagement/chargingTemplate'
import InterConnect from '@/components/chargeManagement/interConnect'


// 会员管理
import MembershipData from '@/components/membershipManagement/membershipData'
import GroupCustomer from '@/components/membershipManagement/groupCustomer'
import GCustomer from '@/components/membershipManagement/gCustomer'
import invoiceissueData from '@/components/membershipManagement/invoiceissueData'

// 运维管理
import TaskManage from '@/components/operationManagement/taskManage'
import AlarmManagement from '@/components/operationManagement/alarmManagement'

// 系统管理
import PrivilegeManagement from '@/components/systemManagement/privilegeManagement'
import BusinessManagement from '@/components/systemManagement/businessManagement'
import SystemLog from '@/components/systemManagement/systemLog'


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login',//设置默认指向的路径
      name: '登录'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      children: [{
        path: '/homePage',
        name: 'homePage',
        component: HomePage,
        meta: {
          title: '运营总览'
        }
      },
      {
        path: '/personalCenter',
        name: 'personalCenter',
        component: PersonalCenter,
        meta: { 
          title: '个人中心' 
        }
      },
      { 
        path: '/realTimeMonitoring/equipmentMonitoring', 
        name: 'equipmentMonitoring', 
        component: EquipmentMonitoring, 
        meta: { 
          title: '设备监控' 
        } 
      },
      { 
        path: '/realTimeMonitoring/videoMonitoring', 
        name: 'videoMonitoring', 
        component: VideoMonitoring, 
        meta: { 
          title: '设备监控' 
        } 
      },
      { 
        path: '/realTimeMonitoring/electricityMonitoring', 
        name: 'electricityMonitoring', 
        component: ElectricityMonitoring, 
        meta: { 
          title: '用电监控' 
        } 
      },
      {
        path: '/dataAnalysis/chargingRevenue',
        name: 'chargingRevenue',
        component: ChargingRevenue,
        meta: {
          title: '充电收入'
        }
      },
      {
        path: '/dataAnalysis/fundRecord',
        name: 'fundRecord',
        component: fundRecord,
        meta: {
          title: '资金管理'
        }
      },
      {
        path: '/dataAnalysis/operationAnalysis',
        name: 'operationAnalysis',
        component: OperationAnalysis,
        meta: {
          title: '运营报告'
        }
      },
      {
        path: '/stationManagement/electricityPayment',
        name: 'electricityPayment',
        component: ElectricityPayment,
        meta: {
          title: '电费缴纳'
        }
      },
      {
        path: '/stationManagement/deviceManagement',
        name: 'deviceManagement',
        component: DeviceManagement,
        meta: {
          title: '设备管理'
        }
      },
      {
        path: '/stationManagement/taskManagement',
        name: 'taskManagement',
        component: TaskManagement,
        meta: {
          title: '合约管理'
        }
      },
      {
        path: '/stationManagement/stationList',
        name: 'stationList',
        component: StationList,
        meta: {
          title: '场站列表'
        }
      },
      {
        path: '/chargeManagement/chargingRecord',
        name: 'ChargingRecord',
        component: ChargingRecord,
        meta: {
          title: '充电记录'
        }
      },
      {
        path: '/chargeManagement/chargingTemplate',
        name: 'ChargingTemplate',
        component: ChargingTemplate,
        // component: InterConnect,
        meta: {
          title: '计费模板'
        }
      },
      {
        path: '/chargeManagement/interConnect',
        name: 'InterConnect',
        component: InterConnect,
        meta: {
          title: '互联互通'
        }
      },
      {
        path: '/membershipManagement/membershipData',
        name: 'MembershipData',
        component: MembershipData,
        meta: {
          title: '会员数据'
        }
      },
      {
        path: '/membershipManagement/groupCustomer',
        name: 'groupCustomer',
        component: GroupCustomer,
        meta: {
          title: '集团客户'
        }
      },
      {
        path: '/membershipManagement/gCustomer',
        name: 'gCustomer',
        component: GCustomer,
        meta: {
          title: '集团客户'
        }
      },
      {
        path: '/membershipManagement/invoiceissueData',
        name: 'invoiceissueData',
        component: invoiceissueData,
        meta: {
          title: '发票记录'
        }
      },
      {
        path: '/operationManagement/taskManage',
        name: 'TaskManage',
        component: TaskManage,
        meta: {
          title: '异常统计'
        }
      },{
        path: '/operationManagement/alarmManagement/',
        name: 'AlarmManagement',
        component: AlarmManagement,
        meta: {
          title: '告警管理'
        }
      },
      {
        path: '/systemManagement/privilegeManagement',
        name: 'privilegeManagement',
        component: PrivilegeManagement,
        meta: {
          title: '访问管理'
        }
      },
      {
        path: '/systemManagement/businessManagement',
        name: 'businessManagement',
        component: BusinessManagement,
        meta: {
          title: '企业管理'
        }
      },
      {
        path: '/systemManagement/systemLog',
        name: 'systemLog',
        component: SystemLog,
        meta: {
          title: '系统日志'
        }
      },]
    }
  ]
})
